import { makeStyles, tokens } from '@fluentui/react-components';

// El encabezado, el pie, el padding y el ritmo de 16 px los da GuideDrawer; los campos, GuideField / GuideFieldGrid.
export const useServiceFormStyles = makeStyles({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: tokens.spacingVerticalXL
  },
  errorList: {
    margin: `${tokens.spacingVerticalS} 0`,
    paddingLeft: tokens.spacingHorizontalL,
    '& li': {
      marginBottom: tokens.spacingVerticalXS
    }
  },
  checkRow: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalS
  }
});
